import { render, staticRenderFns } from "./add_campaign.vue?vue&type=template&id=5a72aba2&scoped=true"
import script from "./add_campaign.vue?vue&type=script&lang=js"
export * from "./add_campaign.vue?vue&type=script&lang=js"
import style0 from "./add_campaign.vue?vue&type=style&index=0&id=5a72aba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a72aba2",
  null
  
)

export default component.exports